import { Input, InputNumber } from 'antd';
import styles from './ContentaInput.module.scss';

const ContentaInput = ({ children, className, ...props }) => (
  <Input
    className={[styles.contentaInput, className].filter(Boolean).join(' ')}
    {...props}
  >
    {children}
  </Input>
);

const ContentaPasswordInput = ({ children, className, ...props }) => (
  <Input.Password
    className={[styles.contentaPasswordInput, className]
      .filter(Boolean)
      .join(' ')}
    {...props}
  >
    {children}
  </Input.Password>
);

const ContentaInputNumber = ({ children, className, ...props }) => (
  <InputNumber
    className={[styles.contentaInputNumber, className]
      .filter(Boolean)
      .join(' ')}
    {...props}
  >
    {children}
  </InputNumber>
);

ContentaInput.Password = ContentaPasswordInput;

export { ContentaInput, ContentaPasswordInput, ContentaInputNumber };
